/* src/app/shared/components/mce-editor/color-palette.component.scss */
.mce-color-btn-wrapper {
  position: relative;
  display: inline-flex;
}
.mce-color-trigger {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 2px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #444;
  gap: 1px;
}
.mce-color-trigger:hover {
  background: #eeeeee;
}
.mce-color-trigger .mce-color-chevron {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #757575;
}
.mce-color-palette {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px;
  min-width: 170px;
}
.mce-color-remove {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 5px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.mce-color-remove mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #757575;
}
.mce-color-remove:hover {
  background: #f5f5f5;
}
.mce-color-grid {
  display: grid;
  grid-template-columns: repeat(5, 24px);
  gap: 3px;
  margin: 6px 0;
}
.mce-color-swatch-btn {
  width: 24px;
  height: 24px;
  border: 2px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  padding: 0;
}
.mce-color-swatch-btn:hover {
  border-color: #757575;
}
.mce-color-swatch-btn--active {
  border-color: #1565c0;
  outline: 1px solid #1565c0;
}
.mce-color-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 4px 0;
}
.mce-color-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
/*# sourceMappingURL=color-palette.component-UUUB2BQ7.css.map */
